import {FaDownload, FaInfoCircle} from "react-icons/fa";
import {Card} from "../../../components/card/card.jsx";
import {Template} from "../../../components/template/template.jsx";

const partialBackups = [
    {label: "Domingo", href: "/backup/ibge-sem-processamento-dom.enc"},
    {label: "Segunda-feira", href: "/backup/ibge-sem-processamento-seg.enc"},
    {label: "Terça-feira", href: "/backup/ibge-sem-processamento-ter.enc"},
    {label: "Quarta-feira", href: "/backup/ibge-sem-processamento-qua.enc"},
    {label: "Quinta-feira", href: "/backup/ibge-sem-processamento-qui.enc"},
    {label: "Sexta-feira", href: "/backup/ibge-sem-processamento-sex.enc"},
    {label: "Sábado", href: "/backup/ibge-sem-processamento-sab.enc"},
];

const dailyBackup = {
    label: "Download",
    href: "/backup/ibge-com-processamento.enc",
};

export default function Backup() {
    const renderBackupLink = ({label, href}) => (
        <a
            key={href}
            href={href}
            target="_blank"
            rel="noreferrer"
            className="flex min-h-[64px] items-center justify-center gap-2 rounded-md border border-[#d7dce2] bg-white px-3 py-4 text-center text-[13px] font-bold text-[#063A6C] transition hover:border-[#063A6C] hover:bg-[#f7fafc] focus:outline-none focus:ring-2 focus:ring-[#063A6C]/30"
        >
            <FaDownload className="shrink-0" />
            <span className="leading-tight">{label}</span>
        </a>
    );

    return (
        <Template>
            <Template.Header>
                <Template.Title>Backup</Template.Title>
            </Template.Header>

            <Template.Body className="space-y-2">
                <Card>
                    <Card.Header>
                        <Card.Title>
                            Backup parcial (não inclui informações de passagens, imagens e anexos de ocorrências)
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
                            {partialBackups.map(renderBackupLink)}
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Header>
                        <Card.Title>
                            Backup diário com informações de passagens (não inclui imagens e anexos de ocorrências)
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
                            {renderBackupLink(dailyBackup)}
                        </div>
                    </Card.Body>
                </Card>

                <div className="flex items-center gap-2 rounded-md border border-[#ededed] bg-white px-3 py-2 text-[13px] italic text-gray-700">
                    <FaInfoCircle className="shrink-0 text-[#063A6C]" />
                    <span>A restauração desses arquivos é feita exclusivamente pelo time de suporte do Sentry.</span>
                </div>
            </Template.Body>
        </Template>
    );
}
